import React from 'react';
import { TenantsTab } from './AdminPage';

const TenantsPage = () => (
  <div className="page admin-page">
    <h2>Tenants</h2>
    <TenantsTab />
  </div>
);

export default TenantsPage;
